module.exports = __webpack_public_path__ + "static/media/logoTQSA.f46aa9ea.png";